/**
 * Footer Component
 * Displays copyright, links, and app version
 */

import React from 'react';
import { Mail, Phone, ExternalLink } from 'lucide-react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-50 border-t border-gray-200 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-lg font-bold text-gray-900 mb-2">
              Loan<span className="text-primary-600">Lens</span>
            </h3>
            <p className="text-sm text-gray-600 mb-4">
              Your trusted partner for home loan solutions. Empowering vendors with seamless
              onboarding.
            </p>
            <p className="text-xs text-gray-500">© {currentYear} LoanLens. All rights reserved.</p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-gray-900 mb-3">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <a
                  href="#"
                  className="text-sm text-gray-600 hover:text-primary-600 transition-colors flex items-center"
                >
                  Privacy Policy
                  <ExternalLink className="w-3 h-3 ml-1" />
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-gray-600 hover:text-primary-600 transition-colors flex items-center"
                >
                  Terms & Conditions
                  <ExternalLink className="w-3 h-3 ml-1" />
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-gray-600 hover:text-primary-600 transition-colors flex items-center"
                >
                  Help & Support
                  <ExternalLink className="w-3 h-3 ml-1" />
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-gray-600 hover:text-primary-600 transition-colors flex items-center"
                >
                  FAQs
                  <ExternalLink className="w-3 h-3 ml-1" />
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-sm font-semibold text-gray-900 mb-3">Contact Us</h4>
            <ul className="space-y-2">
              <li className="flex items-center text-sm text-gray-600">
                <Phone className="w-4 h-4 mr-2 text-primary-600" />
                <a href="tel:+911234567890" className="hover:text-primary-600 transition-colors">
                  +91 123 456 7890
                </a>
              </li>
              <li className="flex items-center text-sm text-gray-600">
                <Mail className="w-4 h-4 mr-2 text-primary-600" />
                <a
                  href="mailto:support@loanlens.in"
                  className="hover:text-primary-600 transition-colors"
                >
                  support@loanlens.in
                </a>
              </li>
            </ul>
            <div className="mt-4">
              <p className="text-xs text-gray-500">
                Version 1.0.0 | Built with ❤️ in India
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 pt-6 border-t border-gray-200">
          <div className="flex flex-col sm:flex-row justify-between items-center space-y-2 sm:space-y-0">
            <p className="text-xs text-gray-500 text-center sm:text-left">
              By continuing, you agree to our Terms of Service and acknowledge our Privacy Policy.
            </p>
            <div className="flex items-center space-x-4">
              <a
                href="#"
                className="text-xs text-gray-500 hover:text-primary-600 transition-colors"
              >
                Cookie Policy
              </a>
              <a
                href="#"
                className="text-xs text-gray-500 hover:text-primary-600 transition-colors"
              >
                Sitemap
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
